var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar0 = function SvgDefaultAvatar0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 55.7c6.6 0 11.4-6.8 11.4-15.8 0-8.8-4.5-15.4-11.1-15.4-6.5 0-11.3 6.6-11.3 15.8 0 8.9 4.6 15.4 11 15.4zm-6.4-16.4c0-6.1 2.1-11.7 6.3-11.7 4.6 0 6.9 6.9 6.9 13.3 0 6-2.1 11.8-6.3 11.8-4.6-.1-6.9-6.9-6.9-13.4z"
  })));
};
export default SvgDefaultAvatar0;